// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.route_route_container__DiEUc {
  background-color: #40445A;
  color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 95%;
  margin: auto;
}
.route_route_container__DiEUc h2 {
  text-align: center;
  color: #ffffff;
  margin-bottom: 20px;
}

.route_route_content__VDviB {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.route_route_section__i02y6 {
  margin-bottom: 20px;
}
.route_route_section__i02y6:last-child {
  margin-bottom: 0;
}

.route_section_title__18Mbl {
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  padding-left: 10px;
}

.route_route_table__ZL1YB {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 10px;
  border: none;
}
.route_route_table__ZL1YB th, .route_route_table__ZL1YB td {
  padding: 10px;
  text-align: left;
  max-width: 150px;
  word-wrap: break-word;
  word-break: break-all;
  border: none;
}
.route_route_table__ZL1YB th {
  background-color: #2D3142;
  border: none;
}
.route_route_table__ZL1YB tr {
  border: none;
}
.route_route_table__ZL1YB tr:hover td {
  background-color: #4C5270;
}
.route_route_table__ZL1YB td {
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/Summary/routing/route.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AACF;AACE;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;AACJ;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;AAEE;EACE,gBAAA;AAAJ;;AAIA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAIA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AADF;AAGE;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;AADJ;AAIE;EACE,yBAAA;EACA,YAAA;AAFJ;AAKE;EACE,YAAA;AAHJ;AAKI;EACE,yBAAA;AAHN;AAOE;EACE,YAAA;AALJ","sourcesContent":[".route_container {\n  background-color: #40445A;\n  color: #fff;\n  padding: 20px;\n  border-radius: 5px;\n  width: 95%;\n  margin: auto;\n\n  h2 {\n    text-align: center;\n    color: #ffffff;\n    margin-bottom: 20px;\n  }\n}\n\n.route_content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.route_section {\n  margin-bottom: 20px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.section_title {\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  padding-left: 10px;\n}\n\n.route_table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  margin-top: 10px;\n  border: none;\n\n  th, td {\n    padding: 10px;\n    text-align: left;\n    max-width: 150px;\n    word-wrap: break-word;\n    word-break: break-all;\n    border: none;\n  }\n\n  th {\n    background-color: #2D3142;\n    border: none;\n  }\n\n  tr {\n    border: none;\n    \n    &:hover td {\n      background-color: #4C5270;\n    }\n  }\n\n  td {\n    border: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"route_container": `route_route_container__DiEUc`,
	"route_content": `route_route_content__VDviB`,
	"route_section": `route_route_section__i02y6`,
	"section_title": `route_section_title__18Mbl`,
	"route_table": `route_route_table__ZL1YB`
};
export default ___CSS_LOADER_EXPORT___;
